export default "__VITE_ASSET__CpvJhbiH__"